import * as React from 'react'
import SpecificIcon from './assets/specific-logo-svg'
import { useOffsetContainerCtx } from './OffsetContainer'
import { cn } from './cn'

type Props = {
  workspaceId: string
  surveyId: string
  chatFinished: boolean
}

const Footer = ({ workspaceId, surveyId, chatFinished }: Props) => {
  const isTouched = useOffsetContainerCtx(s => s.isTouched)
  const device = useOffsetContainerCtx(s => s.device)

  const isFullscreen = device === 'default' && isTouched

  if (isFullscreen && !chatFinished) {
    return null
  }

  return (
    <p
      className={cn({
        'sp-pt-5': chatFinished && !isFullscreen,
        'sp-pt-[30px]': chatFinished && isFullscreen,
      })}>
      <a
        href={new URL(
          `?${new URLSearchParams({
            utm_source: 'survey',
            utm_medium: 'widget',
            utm_ws: workspaceId,
            utm_survey: surveyId,
          })}`,
          'https://specific.app'
        ).toString()}
        target="_blank"
        rel="noreferrer"
        className="sp-flex sp-gap-0.5 sp-justify-center sp-items-center sp-font-medium sp-text-survey-text-placeholder sp-text-xxs"
        onClick={e => {
          e.stopPropagation()
        }}>
        <span>Powered by</span>
        <SpecificIcon width={40} />
      </a>
    </p>
  )
}

export default Footer
